/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {updateCategoryNotificationSettings} from '../api'

export const useMutationUpdateCategoryNotificationSettings = createReactQueryMutationHook('updateCategoryNotificationSettings', updateCategoryNotificationSettings)
